import { IPageViewObject } from '../../types/analytics';
import { IApplicationState } from '../../types/redux';
import { selectUser, selectPage, selectProducts } from '../analytics';
import { selectJsonQuery } from '../jsonQuery';

export function selectPageViewObject(state: IApplicationState): IPageViewObject {
  const page = selectPage(state);
  const user = selectUser(state);
  const products = selectProducts(state);
  const sc = selectJsonQuery(state);

  return {
    page,
    products,
    sc,
    user,
  };
}
